import Joi from "joi";

const makeCall = Joi.object().keys({
  meetingId: Joi.string().required().min(10).messages({
    "string.empty": "MeetingId is required",
    "string.min": "MeetingId must be greater than 10 characters",
    "string.max": "MeetingId must be less than 25 characters",
  }),
});

export { makeCall };
